import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PrintService } from '../../../services/print.service';
import { UserAccount } from '../../../services/userAccount.service';
import { FirebaseService } from 'app/services/firebase.service';

@Component({
  selector: 'print-step-2',
  styleUrls: ['../../wizard/wizard.component.scss', './step2.component.scss'],
  templateUrl: './step2.component.html',
})
export class PrintStep2Component implements OnInit {
  @Input() step;
  @Input() totalSteps;
  @Input() next;
  @Input() prev;

  public addresses;
  public address;
  public state;
  storyId;

  constructor(
    public printService: PrintService,
    public userAccount: UserAccount,
    private activatedRoute: ActivatedRoute,
    private firebaseService: FirebaseService
  ) {}

  ngOnInit() {
    this.loadAddresses();
    this.storyId = this.activatedRoute.snapshot.params.id;
  }

  setState(state) {
    window.scrollTo(0, 0);
    this.state = state;
  }

  loadAddresses() {
    this.printService.getAddresses().subscribe(data => {
      this.addresses = data['results'];
      if (this.addresses.length) {
        this.printService.shippingAddress =
          this.printService.shippingAddress || this.addresses[0];
        this.printService.specs.shipping_address_id = this.printService.shippingAddress.uuid;
        this.setState('list');
      } else {
        this.edit({});
      }
    });
  }

  edit(address) {
    this.setState('edit');
    this.address = { ...address };
  }

  cancelEdit() {
    if (this.addresses.length) {
      this.setState('list');
    } else {
      this.prev();
    }
  }

  save(address) {
    address.errors = undefined;
    this.userAccount.set({ genre: address.salutation === 'mr' ? 'Mr' : 'Mrs' });
    this.printService.saveAddress(address).subscribe(
      data => {
        this.printService.getAddresses().subscribe(addresses => {
          this.addresses = addresses['results'];
          this.printService.shippingAddress = data;
          this.printService.specs.shipping_address_id = this.printService.shippingAddress.uuid;
          if (this.addresses.length === 1 && !address.uuid) {
            this.goToNextStep();
          } else {
            this.setState('list');
          }
        });
      },
      data => {
        this.address.errors = data.error;
      }
    );
  }

  remove = address => {
    this.printService.deleteAddresses(address).subscribe(data => {
      this.printService.shippingAddress = undefined;
      this.printService.specs.shipping_address_id = undefined;
      this.loadAddresses();
    });
  };

  isNextStepDisabled() {
    if (this.state === 'edit') {
      return false;
    } else {
      return !this.addresses;
    }
  }

  goToNextStep() {
    this.firebaseService.logEvent('checkout_address_select', {
      story_id: this.printService.storyId,
      project_id: this.printService.projectId,
    });
    this.next();
  }
}
